import { ChangeDetectorRef, Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { AccountService, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { debounceTime, delay, take, takeUntil, tap } from "rxjs/operators";
import { SplashFormService } from "../../../../projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { TabularService } from "../../../../projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { DialogType } from "../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "../../../../projects/sepidz-web-framework/src/lib/models/enums";
import {
  AssignInvoiceViewModel,
  CurrentTime,
  DeleteDriverAssignment,
  DriverAssignGetInvoiceViewModel,
  DriverAssignment,
  DriverAssignmentStatus,
  Invoice,
  InvoiceCommand,
  InvoiceItem,
  InvoiceStatus,
} from "../order/model/invoice.model";
import { UpdateClientFactorState } from "../order/model/update-Client-Factor-State.enum";
import { OrderService } from "../order/order.service";
import { InvoicePrintService } from "../order/providers/invoiceprint.service";
import { CreditControlType } from "../parties/model/customer.model";
import { DriverAssignDeliverd } from "../parties/model/driverassigndeliverd.model";
import { DriverAttendanceStatus, DriverStatus, DriverStatusShow, Personnel, PersonnelState } from "../parties/model/personnel.model";
import { PrintPolicyPrintTimeEnum } from "../prints/model/print-policy.model";
import { SaleMethodNature } from "../sales/model/sale-method-branch.model";
import { DescriptionAssignmentFormComponent } from "./DesceriptionAssignment/dynamic-input-form.component";
import { DriverAssignementFormSettingModel } from "./driverassignementformsetting.model";
import { ExternalNotification, ExternalNotificationKindEnum, ExternalNotificationStateKindEnum } from "./external-notification.model";

@Injectable()
export class DriverAssignementService extends BaseService {
  invoiceFilter: any[] = [
    {
      key: 0,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.Preparing"),
      count: 0,
      selected: false,
    },
    {
      key: 1,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.DelayInPreparation"),
      count: 0,
      selected: false,
    },
    {
      key: 2,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.ExcessiveDelay"),
      count: 0,
      selected: false,
    },
  ];

  DriverFilter: any[] = [
    {
      key: DriverStatusShow.DriverIn,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.PresentPeyk"),
      count: 0,
      selected: false,
      hasFastAccess: true,
    },
    {
      key: DriverStatusShow.DriverOut,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.OutOfPeyk"),
      count: 0,
      selected: false,
      hasFastAccess: true,
    },
    {
      key: DriverStatusShow.DriverReadyToWork,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.StandbyPeyk"),
      count: 0,
      selected: false,
      hasFastAccess: false,
    },
    {
      key: DriverStatusShow.All,
      title: this.translate("ClientApp.FrontOffice.DriverAssignment.BranchOfPeky"),
      count: 0,
      selected: false,
      hasFastAccess: false,
    },
  ];
  deliverySaleMethodData: any[] = [];
  invoices: AssignInvoiceViewModel[];
  currentInvoices: AssignInvoiceViewModel[] = [];
  tempCurrentInvoices: AssignInvoiceViewModel[];
  invoicestatus: typeof InvoiceStatus = InvoiceStatus;
  isShowAssignInvoice: boolean;
  showFleetMap: boolean;
  showNotification: boolean;
  drivers: Personnel[];
  currentDrivers: Personnel[];
  tempDrivers: Personnel[];
  driverAssignmentStatus: typeof DriverAssignmentStatus = DriverAssignmentStatus;
  driverStatus: typeof DriverStatus = DriverStatus;
  personnelState: typeof PersonnelState = PersonnelState;
  driverStatusShow: typeof DriverStatusShow = DriverStatusShow;
  driverAttendanceStatus: typeof DriverAttendanceStatus = DriverAttendanceStatus;
  DriverAttendanceStatusLookup: Lookup[];
  DriverStatusLookup: Lookup[];
  currentDriverFilter: DriverStatusShow;
  _svgFillCodes: any;
  isFastAccess: boolean;
  DateNow: string;
  selectedDriver: Personnel;
  refreshWithNotification: boolean = false;
  timeLeft: number = 60;
  interval;
  _id: string;
  formsetting: DriverAssignementFormSettingModel;
  public searchInput: string;
  public formGroup: UntypedFormGroup;
  public inputSearch: string;
  public inputBarCode: string;
  public barcodeInput: string;
  public invoiceByBarCode: AssignInvoiceViewModel;
  public driveIdByBarCode: Personnel;
  public nearDriver: string[];
  public notificationList: { PersonnelId: number; PersonnelImage?: string; PersonnelName?: string; value: ExternalNotification[] }[] = [];
  public description: string;
  public newNotificationCount: number;

  private isReadAPICalled: boolean = false;
  accessToGetDrivers = true;

  currentBranchId = this.accountService.authService.currentBranch.Id;
  hasCourierFleet: boolean = false;

  constructor(
    public order: OrderService,
    public splashFormService: SplashFormService,
    public tabsservice: TabularService,
    public invoicePrint: InvoicePrintService,
    protected selectorService: SelectorService,
    protected accountService: AccountService,
    protected cd: ChangeDetectorRef,
    private lookupservice: LookupService,
    private notification: NotificationService
  ) {
    super();
    this.hasCourierFleet = accountService.authService.currentInformation().SafirCourierFleetManagement;
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
    let group: any = {};
    group["drvierAssignmentDate"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["searchInput"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["barcodeInput"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["SaleMethodBranchIds"] = new UntypedFormControl(undefined);
    this.formGroup = new UntypedFormGroup(group);
    this.FillData();
    this.GetAllDrivers();
    this.init();
    this.startTimer();
  }

  ngOnInit() {
    super.ngOnInit();
    this.focus();
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);

    super.ngOnDestroy();
  }

  setFormGroupValue() {
    let group: any = {};
    group["drvierAssignmentDate"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group[this.inputSearch] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group[this.inputBarCode] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group[this.description] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["SaleMethodBranchIds"] = new UntypedFormControl(undefined);
    this.formGroup = new UntypedFormGroup(group);
    this.formGroup.controls["drvierAssignmentDate"].setValue(this.DateNow);
    this.formGroup.controls[this.inputSearch].setValue(this.searchInput);
    this.formGroup.controls[this.inputBarCode].setValue(this.barcodeInput);
    this.formGroup.controls["SaleMethodBranchIds"].setValue(null);
  }
  public focus() {
    const input: HTMLInputElement = document.getElementById(this.inputBarCode) as HTMLInputElement;
    if (input) {
      input.focus();
      input.select();
    }
  }

  private init(): void {
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if ((value.Key === "InvoiceChanges" && value.Message === SaleMethodNature.Delivery) || value.Key === "SettlementChanges") {
        this.refreshWithNotification = true;
        this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
        this.GetAllDrivers();
        this.cd.markForCheck();
      }
      if (value.Key === "DriverSweep") {
        if (this.accessToGetDrivers) {
          if (typeof value.Message === "number") this.getDriverById(value.Message);
          this.cd.markForCheck();
        }
      }
      if (value.Key === "UpdateSafirToken") {
        const info = this.accountService.authService.currentInformation();
        info.SafirToken = value.Message;
        this.storage.saveSessionData(info, "current_information");
      }
      if (value.Key === "NewNotification") {
        this.getExternalNotification();
      }
    });
  }

  getExternalNotification() {
    this.httpCommonService
      .getList(`ExternalNotification/GetAllNotificationByKind/${ExternalNotificationKindEnum.Fleet}`)
      .pipe(take(1))
      .subscribe((result: any[]) => {
        this.notificationList = result;
        if (this.drivers !== null && this.drivers?.length) {
          this.notificationList.forEach((f) => {
            const driver = this.drivers?.find((h) => h.Id === f?.PersonnelId);
            f.PersonnelName = driver.UserDisplayName ?? driver.FirstName + " " + driver.LastName;
            f.PersonnelImage = driver.Image;
            this.cd.markForCheck();
          });
        }
        const flatNotification = this.notificationList.map((m) => m.value).reduce((acc, val) => acc.concat(val), []);
        this.newNotificationCount = flatNotification.filter((f) => f.NotificationState !== ExternalNotificationStateKindEnum.Seen).length;
      });
  }

  seenNotification(notifications: { PersonnelId: number; PersonnelImage?: string; PersonnelName?: string; value: ExternalNotification[] }) {
    const seenNotification = notifications.value.filter((f) => f.NotificationState !== ExternalNotificationStateKindEnum.Seen);
    if (seenNotification.length) {
      this.httpCommonService
        .create(
          "ExternalNotification/SeenNotification",
          seenNotification.map((m) => m.Id)
        )
        .pipe(take(1))
        .subscribe((result: any) => {
          setTimeout(() => {
            this.notificationList.forEach((f) => {
              if (f.PersonnelId === notifications.PersonnelId) {
                f.value = f.value.map((notification) => {
                  const sourceItem = result.find((source) => source.Id === notification.Id);
                  return sourceItem ? sourceItem : notification;
                });
              }
            });
            const flatNotification = this.notificationList.map((m) => m.value).reduce((acc, val) => acc.concat(val), []);
            this.newNotificationCount = flatNotification.filter((f) => f.NotificationState !== ExternalNotificationStateKindEnum.Seen).length;
          }, 2000);
        });
    }
  }

  addControl() {
    this.formGroup.controls["drvierAssignmentDate"].setValue(this.DateNow);
    this.formGroup.controls["searchInput"].setValue(this.searchInput);
    this.formGroup.controls["barcodeInput"].setValue(this.barcodeInput);
    this.formGroup.controls["SaleMethodBranchIds"].setValue(null);
  }

  FillData() {
    this.getDriverStateLookupItem();
    this.httpCommonService
      .getList("DriverAssignementFormSetting")
      .pipe(take(1))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.formsetting = result[0];
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
    this.addControl();
    this._svgFillCodes = { 1: "#e0dede", 2: "#5161d0" };

    /// پرینت  لوکال
    this.invoicePrint.currentBranch = this.accountService.authService.currentBranch;
    this.invoicePrint.PreData();
  }

  //-----------------------------------------------------------------------Invoices
  //دریافت همه فاکتورها
  GetAllInvoices(date?: Date) {
    if (this.isReadAPICalled) return;
    const element = new DriverAssignGetInvoiceViewModel();
    element.UntilDate = date;
    this.isReadAPICalled = true;
    this.httpCommonService
      .create(`Invoice/ReadInvoiceForDriverAssignment`, element)
      .pipe(
        take(1),
        tap((data: AssignInvoiceViewModel[]) => {
          this.isReadAPICalled = false;
          if (!data && data.length <= 0) {
            this.sts.showToast(
              "info",
              this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage"),
              this.translate("ClientApp.FrontOffice.DriverAssignment.NoPendingInvoicesFound")
            );
          }
          let temp = this.invoices ? this.invoices.filter((x) => x.Selected) : undefined;
          if (!this.isMultiBranch) {
            if (this.formGroup.controls["SaleMethodBranchIds"].value?.length) {
              data = data.filter((x) => this.formGroup.controls["SaleMethodBranchIds"].value.includes(x.SaleMethodBranchId));
            }
            this.invoices = data.filter((x) => x.BranchId === this.accountService.authService.currentBranch.Id);
          }
          if (this.refreshWithNotification) {
            this.refreshWithNotification = false;

            if (temp !== undefined) {
              temp.forEach((x) => {
                if (this.invoices.some((i) => i.Id == x.Id)) this.invoices.find((i) => i.Id == x.Id).Selected = x.Selected;
              });
            }
          }
        }),
        delay(500)
      )
      .subscribe(
        (data: AssignInvoiceViewModel[]) => {
          this.changeInvoiceBystatus();
          this.cd.markForCheck();
        },
        (err) => {
          this.splashFormService.closeLoading();
          this.isReadAPICalled = false;
        }
      );
  }

  saleMethodBranchChanges(value: number) {
    this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
  }

  //اعمال فیلتر بر اساس حالات
  invoiceFilterByStatus() {
    const selectedList = this.invoiceFilter.filter((f) => f.selected);
    this.tempCurrentInvoices = JSON.parse(JSON.stringify(this.currentInvoices));
    if (selectedList && selectedList.length > 0) {
      this.currentInvoices = [];
      selectedList.forEach((element) => {
        const filterItem = this.tempCurrentInvoices.filter((f) => f.DriverAssignmentStatus === element.key);
        filterItem.forEach((ele) => {
          this.currentInvoices.push(ele);
        });
      });
    } else {
      this.changeInvoiceBystatus();
    }
  }

  // تغییر فاکتور ها به ارسال شده و نشده
  changeInvoiceBystatus(isAssign?: boolean) {
    this.invoiceFilter.forEach((element) => {
      element.count = 0;
    });
    if (isAssign !== null && isAssign !== undefined) {
      this.isShowAssignInvoice = isAssign;
    }
    this.currentInvoices = this.invoices.filter((f) =>
      this.isShowAssignInvoice ? f.StatusCode === InvoiceStatus.Assigned : f.StatusCode !== InvoiceStatus.Assigned
    );
    if (this.currentInvoices)
      this.currentInvoices.forEach((element) => {
        const find = this.invoiceFilter.find((f) => f.key === element.DriverAssignmentStatus);
        if (find) find.count += 1;
      });
    this.splashFormService.closeLoading();
    this.cd.markForCheck();
  }

  hasSelectItem(): boolean {
    if (this.currentInvoices && this.currentInvoices.some((s) => s.Selected)) return true;
    else return false;
  }

  //-----------------------------------------------------------------------Drivers
  //دریافت همه پیک ها
  GetAllDrivers() {
    this.httpCommonService
      .getList("Personnel/GetDriverAssignmentPersonnel")
      .pipe(take(1))
      .subscribe(
        (data: Personnel[]) => {
          const currentInformation = this.accountService.authService.currentInformation();
          if (
            (currentInformation.BranchingAdvancedEnabled || currentInformation.BranchingLightEnabled || currentInformation.RestaurantCallCenter) &&
            !this.accountService.authService.currentBranch?.AccessToAllBranches
          ) {
            data = data.filter((x) => !!x.Branches?.find((x) => x.BranchId == this.accountService.authService.currentBranchId));
          }
          this.drivers = data;
          this.drivers?.forEach((element) => {
            element.CurrentBranch = element.Branches?.find((x) => x.BranchId === this.accountService.authService.currentBranchId);
          });
          this.getDriverCounts();
          // فعال کردن فیلتر پیک های حاضر
          if (!this.currentDriverFilter) {
            this.currentDriverFilter = this.DriverFilter[0].key;
            this.DriverFilter[0].selected = true;
          }
          this.notificationList?.forEach((f) => {
            const driver = this.drivers?.find((h) => h.Id === f?.PersonnelId);
            f.PersonnelName = driver.UserDisplayName ?? driver.FirstName + " " + driver.LastName;
            f.PersonnelImage = driver.Image;
          });
          this.driverFilterByStatus(this.currentDriverFilter);
          this.splashFormService.closeLoading();
        },
        (err) => this.splashFormService.closeLoading()
      );
  }

  /// گرفتن شناسه وضعیت های مختلف پیک
  getDriverStateLookupItem() {
    this.lookupservice
      .getLookupbyCategory("SALE", "DriverAttendanceStatus")
      .pipe(take(1))
      .subscribe((DriverAttendanceStatus) => {
        this.DriverAttendanceStatusLookup = DriverAttendanceStatus;
      });
    this.lookupservice
      .getLookupbyCategory("SALE", "DriverStatus")
      .pipe(take(1))
      .subscribe((DriverStatus) => {
        this.DriverStatusLookup = DriverStatus;
      });
  }

  ///اعمال فیلتر براساس وضعیت راننده
  driverFilterByStatus(filter: DriverStatusShow) {
    this.currentDriverFilter = filter;
    this.selectedDriver = null;
    switch (filter) {
      case DriverStatusShow.DriverIn:
        this.currentDrivers = this.drivers.filter(
          (f) =>
            f.IsActive &&
            f.CurrentBranch.DriverAttendanceStatusCode === DriverAttendanceStatus.Present &&
            f.CurrentBranch.DriverStatusCode === DriverStatus.In
        );
        this.currentDrivers = this.currentDrivers.sort((a, b) => {
          return <any>new Date(a.ModifiedDate) - <any>new Date(b.ModifiedDate);
        });
        break;
      case DriverStatusShow.DriverOut:
        this.currentDrivers = this.drivers.filter(
          (f) =>
            f.IsActive &&
            f.CurrentBranch.DriverAttendanceStatusCode === DriverAttendanceStatus.Present &&
            f.CurrentBranch.DriverStatusCode === DriverStatus.Out
        );
        break;
      case DriverStatusShow.DriverReadyToWork:
        this.currentDrivers = this.drivers.filter((f) => f.IsActive);
        break;
      case DriverStatusShow.All:
        this.currentDrivers = this.drivers;
        break;
    }
    this.currentDrivers.forEach((driver) => {
      const personnelBranch = driver.Branches.find((x) => x.BranchId === this.currentBranchId);
      driver.IsFleet = !!personnelBranch?.VehicleId;
    });
    this.cd.markForCheck();
  }

  //برگشت از تحویل
  ReturnOfDelivery(driver: Personnel) {
    if (driver) {
      if (driver.Freeze) return;
      driver.FilterDate = this.formGroup.controls["drvierAssignmentDate"].value.toString().replace(/['/']/g, "-");
      driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Id;
      driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Code;
      const invoicesIds = driver.DriverAssignments.filter((x) => !x.DriverReturnDate).map((x) => x.Invoice.Id);
      const driverInfo = new DriverAssignDeliverd();
      driverInfo.InvoiceIds = invoicesIds;
      driverInfo.DriverId = driver.Id;
      this.accessToGetDrivers = false;
      this.driverFilterByStatus(this.currentDriverFilter);
      this.getDriverCounts();
      driver.Freeze = true;
      this.httpCommonService
        .create("Invoice/SetDriverAssignmentDeliveredDateTime", driverInfo)
        .pipe(
          take(1),
          tap((data: Personnel) => {
            data.CurrentBranch = data.Branches?.find((x) => x.BranchId === this.accountService.authService.currentBranchId);
            const currentIndex = this.currentDrivers.findIndex((x) => x.Id === data.Id);
            if (currentIndex >= 0) this.currentDrivers[currentIndex] = data;
            data.Freeze = false;
            const index = this.drivers.findIndex((x) => x.Id === data.Id);
            if (index >= 0) this.drivers[index] = data;
            this.splashFormService.closeLoading();
            this.driverFilterByStatus(this.currentDriverFilter);
            this.getDriverCounts();
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
          }),
          delay(1000)
        )
        .subscribe(
          (data: Personnel) => {
            this.accessToGetDrivers = true;
          },
          (error) => {
            driver.Freeze = false;
            this.sts.showDialog(`${Utilities.getHttpResponseMessage(error)}`, this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage"));
          }
        );
    }
  }

  //تغییر وضعیت پیک
  ChangeDriverStatus(driver: Personnel, state: PersonnelState) {
    if (driver.Freeze) return;
    switch (state) {
      case PersonnelState.Present:
        driver.CurrentBranch.DriverAttendanceStatusCode = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Present
        ).Code;
        driver.CurrentBranch.DriverAttendanceStatusId = this.DriverAttendanceStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Present).Id;
        driver.CurrentBranch.DriverAttendanceStatusTitle = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Present
        ).Title;
        driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Id;
        driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Code;
        break;
      case PersonnelState.Absent:
        driver.CurrentBranch.DriverAttendanceStatusCode = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Absent
        ).Code;
        driver.CurrentBranch.DriverAttendanceStatusId = this.DriverAttendanceStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Absent).Id;
        driver.CurrentBranch.DriverAttendanceStatusTitle = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Absent
        ).Title;
        driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.Out).Id;
        driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.Out).Code;
        break;
      case PersonnelState.In:
        driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Id;
        driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.In).Code;
        break;
      case PersonnelState.Out:
        driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.Out).Id;
        driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverStatus.Out).Code;
        break;
      case PersonnelState.Active:
        const findItemActive = driver.Branches.find((f) => f.BranchId === this.accountService.authService.currentBranchId);
        findItemActive ? (findItemActive.IsActive = true) : null;
        findItemActive ? (findItemActive.State = RowState.Modify) : null;
        driver.CurrentBranch.DriverAttendanceStatusId = this.DriverAttendanceStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Absent).Id;
        driver.CurrentBranch.DriverAttendanceStatusCode = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Absent
        ).Code;
        driver.CurrentBranch.DriverAttendanceStatusTitle = this.DriverAttendanceStatusLookup.find(
          (f) => f.Code === DriverAttendanceStatus.Absent
        ).Title;
        break;
      case PersonnelState.Deactive:
        const findItemDeactive = driver.Branches.find((f) => f.BranchId === this.accountService.authService.currentBranchId);
        findItemDeactive ? (findItemDeactive.IsActive = false) : null;
        findItemDeactive ? (findItemDeactive.State = RowState.Modify) : null;
        driver.CurrentBranch.DriverStatusId = this.DriverStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Absent).Id;
        driver.CurrentBranch.DriverStatusCode = this.DriverStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Absent).Code;
        driver.CurrentBranch.DriverStatusTitle = this.DriverStatusLookup.find((f) => f.Code === DriverAttendanceStatus.Absent).Title;
        break;
    }
    const branchIndex = driver.Branches.findIndex((f) => f.BranchId === this.accountService.authService.currentBranchId);
    driver.CurrentBranch.State = RowState.Modify;
    driver.Branches[branchIndex] = driver.CurrentBranch;
    this.driverFilterByStatus(this.currentDriverFilter);
    this.getDriverCounts();
    this.accessToGetDrivers = false;
    driver.Freeze = true;
    this.httpCommonService
      .put("Personnel/UpdateDriver", driver)
      .pipe(
        take(1),
        tap((data) => {
          data.CurrentBranch = data.Branches?.find((x) => x.BranchId === this.accountService.authService.currentBranchId);
          const currentIndex = this.currentDrivers.findIndex((x) => x.Id === data.Id);
          if (currentIndex >= 0) this.currentDrivers[currentIndex] = data;
          const index = this.drivers.findIndex((x) => x.Id === data.Id);
          if (index >= 0) this.drivers[index] = data;
          this.cd.markForCheck();
          this.cd.detectChanges();
          this.driverFilterByStatus(this.currentDriverFilter);
          this.getDriverCounts();
          data.Freeze = false;
          this.cd.markForCheck();
          this.cd.detectChanges();
        }),
        delay(1000)
      )
      .subscribe(
        (data) => {
          this.accessToGetDrivers = true;
        },
        (error) => {
          this.driverFilterByStatus(this.currentDriverFilter);
          this.getDriverCounts();
          this.accessToGetDrivers = true;
          driver.Freeze = false;
          this.splashFormService.closeLoading();
          return this.sts.showDialog(
            `${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage")
          );
        }
      );
  }

  normalizeBarcodeInput(input: string): string {
    return input.replace(/إ/g, "B").replace(/ِ/g, "D");
  }

  // متد مربوط به وارد کردن بارکد برای انتخاب فاکتور بر اساس بارکد
  public async barCodeFinder(event: string) {
    if (!event) return;
    const normalizedEvent = this.normalizeBarcodeInput(event);
    if (normalizedEvent.startsWith("B0") || normalizedEvent.startsWith("D0")) {
      if (normalizedEvent.startsWith("B0")) {
        const numberingInDateCode = normalizedEvent.slice(2); // حذف "B0"
        this.invoiceByBarCode = this.invoices?.find((f) => f.NumberingInDate === Number(numberingInDateCode));
      } else if (normalizedEvent.startsWith("D0")) {
        const driverNumberCode = normalizedEvent.slice(2); // حذف "D0"
        this.driveIdByBarCode = this.drivers?.find((f) => f.Number === Number(driverNumberCode));
      }
      if (this.invoiceByBarCode.Selected) this.InvoiceAssigned(this.driveIdByBarCode);
      else this.selectedInvoice(this.invoiceByBarCode);
      this.formGroup.controls[this.inputBarCode].setValue("");
      return;
    } else {
      this.invoiceByBarCode = this.invoices?.find((f) => f.NumberingInDate === Number(normalizedEvent));
      this.driveIdByBarCode = this.drivers?.find((f) => f.Number === Number(normalizedEvent));
      if (this.invoiceByBarCode?.NumberingInDate === this.driveIdByBarCode?.Number) {
        if (!this.invoiceByBarCode.Selected && !this.isShowAssignInvoice) this.selectedInvoice(this.invoiceByBarCode);
        else if (!this.isShowAssignInvoice) this.InvoiceAssigned(this.driveIdByBarCode);
      } else {
        this.selectedInvoice(this.invoiceByBarCode);
        if (this.driveIdByBarCode) this.InvoiceAssigned(this.driveIdByBarCode);
      }
      this.formGroup.controls[this.inputBarCode].setValue("");
    }
  }

  //متد مربوط به انتخاب فاکتور و اضافه کردن کلاس / استایل انتخاب به فاکتور
  public async selectedInvoice(invoice: Invoice) {
    if (!this.isShowAssignInvoice) {
      if (invoice.Selected > 0) {
        invoice.Selected = null;
      } else {
        const ind = this.currentInvoices.getSumWithKey("Selected");
        if (ind > 0) invoice.Selected = ind + 1;
        else invoice.Selected = 1;
      }
    }
  }

  public async selectedDrive(driver) {
    if (this.isShowAssignInvoice) this.SelectDriverInDontSent(driver);
  }

  //انتخاب پیک وفیلتر فاکتور های ارسال شده بر اساس پیک انتخاب شده
  SelectDriverInDontSent(driver: Personnel) {
    driver.selected = !driver.selected;
    this.selectedDriver = driver;
    if (this.currentDrivers.some((s) => s.selected) && !driver) this.currentInvoices = JSON.parse(JSON.stringify(this.invoices));
    else
      this.currentInvoices = JSON.parse(
        JSON.stringify(this.invoices.filter((f) => f.DriverId === driver.Id && f.StatusCode === InvoiceStatus.Assigned))
      );
  }

  //اختصاص به پیک
  async InvoiceAssigned(driver: Personnel) {
    const hasExit = this.storage.getData(ClearableCache.FormSetting)?.AutoExitCourier;
    let numberOfInvAssign = this.storage.getData(ClearableCache.FormSetting)?.numberInvSameTimeAssignToCourier;
    const selectedInvoices = this.currentInvoices.filter((f) => f.Selected > 0);
    if (numberOfInvAssign === null) numberOfInvAssign = 0;
    if (numberOfInvAssign !== 0 && selectedInvoices.length > numberOfInvAssign) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.DriverAssignment.NumberOfAllocatedInvoicesExceededLimit"),
        this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage")
      );
      return;
    }
    if (!this.accountService.authService.currentBranch.multiOrder && this.currentInvoices?.filter((f) => f.Selected)?.length > 1 && driver.IsFleet) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.DriverAssignment.NumberAllocatedInvoicesExceedsAmbassadorLimit"),
        this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage")
      );
    }
    driver.SelectedInvoicesTotal = 0;
    let mapper = new MapObjectPipe();
    this.currentInvoices?.forEach((element) => {
      element.DriverAssignments = new DriverAssignment();
      element.DriverAssignments.DriverId = driver?.Id;
      element.DriverAssignments.DriverDisplayName = driver?.DisplayName;
      element.DriverAssignments.InvoiceId = element?.Id;
      element.CustomerNumber = element?.CustomerNumber;
      element.HasLocalPrtinter = this.invoicePrint.HasLocalPrint;
      if (element.Selected > 0) driver.SelectedInvoicesTotal += element?.PayableTotal;
      const output = new Invoice();
      element.OriginalValue = mapper.transform(element, output);
    });
    if (driver && this.hasSelectItem()) {
      if (driver.HasCredit) {
        //اگر پیک اعتباری بود
        let terminate = false;
        await this.CreditControlType(driver).then(
          (onfulfilled) => {
            setTimeout(() => {
              this.order._opened = true;
              this.order.detectChanges();
            }, 5);
          },
          (onrejected) => {
            terminate = true;
            setTimeout(() => {
              this.order._opened = true;
              this.order.detectChanges();
            }, 5);
          }
        );
        if (terminate) return;
      }

      this.splashFormService.openDialog();
      const printInvoices: Invoice[] = [];

      const computerName: string = this.storage.getData(ClearableCache.ComputerName);
      const InvoiceList = this.currentInvoices
        .filter((f) => f.Selected > 0)
        .sort((a, b) => {
          return a.Selected - b.Selected;
        });
      this.httpCommonService
        .create("Invoice/SetDriverAssignment" + (computerName ? "?ComputerName=" + computerName : ""), InvoiceList)
        .pipe(take(1))
        .subscribe(
          (items: InvoiceItem[]) => {
            this.currentInvoices.forEach((x) => {
              x.Items = items.filter((i) => i.InvoiceId === x.Id);
            });
            this.currentInvoices
              .filter((f) => f.Selected > 0)
              .forEach(async(inv) => {
                if (inv.WebId && inv.WebId !== 0) this.setClientFactorState(inv.WebId);
                if (this.accountService.authService.currentBranch.HasLocalService || inv.HasLocalPrtinter) {
                  inv.HasLocalPrtinter = this.accountService.authService.currentBranch.HasLocalService;
                  inv.DeliveryCustomerPrintTimeCode = inv.DeliveryCustomerPrintTimeCode;
                  inv.CommandCode = InvoiceCommand.Assign;
                  inv.CustomerAddres = inv.Address;
                  inv.PhoneNumber = inv.PhoneNumber;
                  inv.CustomerDisplayName = inv.CustomerDisplayName;
                  inv.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
                  if (this.accountService.authService.currentBranch?.HasTotalDebit) {
                    const invoice = new Invoice();
                    invoice.CustomerId = inv.CustomerId;
                    this.httpCommonService
                      .create(`Invoice/GetCredit`, invoice)
                      .pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe(async (res) => {
                        inv.CustomerTotalDebit = res;
                        await this.invoicePrint.PrintLocalInvoice(inv,true).then();
                      });
                  } else {
                    await this.invoicePrint.PrintLocalInvoice(inv,true).then();
                  }
                }
              });
            this.currentInvoices.forEach((i) => {
              i.Selected = null;
            });

            if (printInvoices?.length > 0) {
              this.currentInvoices.forEach(async(i) => {
                await this.invoicePrint.PrintLocalInvoice(i,true).then();
              });
            }

            if (hasExit) this.ChangeDriverStatus(driver, PersonnelState.Out);
            else this.GetAllDrivers();

            this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`${Utilities.getHttpResponseMessage(error)}`, this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage"));
          }
        );
    }
  }

  //لغو اختصاص به پیک
  CancelAssignment(invoice: any) {
    const ctrls = this.getDescriptionControls();
    const mod = new DeleteDriverAssignment();
    mod.Id = invoice.Id;
    mod.BranchId = invoice.BranchId;
    mod.FiscalYearId = invoice.FiscalYearId;
    mod.DriverId = invoice?.DriverId;
    this.dialogService
      .open(DescriptionAssignmentFormComponent, { formColumns: ctrls }, {})
      .pipe(take(1))
      .subscribe((x) => {
        const des: string = x;
        mod.UnAssignmentDesceription = des;
        if (mod) {
          this.splashFormService.openDialog();
          this.httpCommonService
            .create("Invoice/DeleteDriverAssignment", mod)
            .pipe(take(1))
            .subscribe(
              () => {
                this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
                this.GetAllDrivers();
              },
              (error) => {
                this.splashFormService.closeLoading();
                this.sts.showDialog(
                  `${Utilities.getHttpResponseMessage(error)}`,
                  this.translate("ClientApp.FrontOffice.DriverAssignment.ErrorMessage")
                );
              }
            );
        }
      });
  }

  private getDescriptionControls() {
    const ctrl = new form_control();
    ctrl.name = "UnAssignmentDesceription";
    ctrl.label = this.translate("ClientApp.FrontOffice.DriverAssignment.Description");
    ctrl.formVisible = true;
    ctrl.userClass = "select-md";
    ctrl.columnNumber = 1;
    ctrl.controlType = FormControlTypes.textbox;
    ctrl.required = true;
    return [ctrl];
  }

  //دریافت فاکتور بر اساس تاریخ
  GetAllInvoicesByDate(event) {
    if (event && event.toString().includes("/")) {
      if (!this.isFastAccess) this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
      else {
        this.GetAllInvoices(event);
      }
    }
  }

  //روش کنترل اعتبار
  CreditControlType(driver: Personnel): Promise<boolean> {
    return new Promise((resolve, reject) => {
      switch (driver.CreditControlTypeCode) {
        case CreditControlType.Warning:
          if (driver.AssignmentInvoicesTotal + (driver.SelectedInvoicesTotal ? driver.SelectedInvoicesTotal : 0) >= driver.CreditLimit)
            this.sts.showDialog(
              `(${driver.DisplayName}) ${this.translate("ClientApp.FrontOffice.DriverAssignment.MaximumCreditLimitReached")}`,
              this.translate("ClientApp.FrontOffice.DriverAssignment.CreditControlMethod"),
              DialogType.confirm,
              (ok) => {
                resolve(true);
              },
              (cancel: void) => {
                reject(false);
                this.sts.showToast(
                  "info",
                  `${driver.DisplayName}`,
                  `${this.translate("ClientApp.FrontOffice.DriverAssignment.NeedToSettleWithCourier")}`,
                  5000
                );
              }
            );
          else resolve(true);
          break;
        case CreditControlType.Inhibit:
          if (driver.AssignmentInvoicesTotal + (driver.SelectedInvoicesTotal ? driver.SelectedInvoicesTotal : 0) >= driver.CreditLimit) {
            reject(false);
            this.sts.showToast(
              "info",
              `${driver.DisplayName}`,
              `${this.translate("ClientApp.FrontOffice.DriverAssignment.MaximumCreditLimiBeenReached")}`,
              5000
            );
          } else resolve(true);
          break;
        default:
          resolve(true);
      }
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.GetAllInvoices(this.formGroup.controls["drvierAssignmentDate"].value);
      this.refreshTableTimeLeft();
    }, 100000);
  }

  refreshTableTimeLeft() {
    this.httpCommonService
      .getList("Invoice/RefreshInvoiceTime")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: CurrentTime) => {
        this.currentInvoices.forEach((item) => {
          //اگر در تب فاکتور های ارسال نشده بود
          if (!this.isShowAssignInvoice) item.FactorStringTime = item.FactorStringTime;
        });
        this.cd.markForCheck();
      });
  }

  calculateDiff(startDate, endDate): string {
    let date = new Date(startDate);
    let currentDate = new Date(endDate);
    let chaneDate = Math.floor(currentDate.getTime() - date.getTime());
    var Days = chaneDate / (1000 * 3600 * 24);
    var hours = Math.floor(currentDate.getHours() - date.getHours());
    var minutes = Math.floor(currentDate.getMinutes() - date.getMinutes());
    if (Days < 1) Days = 0;
    if (hours < 1) hours = 0;
    if (minutes < 1) minutes = 0;
    return `${Days}.${hours}:${Math.round(minutes)}`;
  }

  /// ارسال کد تغییر وضعیت فاکتور
  setClientFactorState(DelinoId: number) {
    this.httpCommonService
      .get(`Delino/SetClientFactorState/${DelinoId}/${UpdateClientFactorState.SentToCustomer}`)
      .pipe(take(1))
      .subscribe(
        (data) => {},
        (error) => console.log(error)
      );
  }

  refreshSetting() {
    this.httpCommonService
      .getList("DriverAssignementFormSetting")
      .pipe(take(1))
      .subscribe((result: any[]) => {
        if (result?.length > 0) this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
      });
  }

  getDriverById(personnelId: number) {
    this.httpCommonService
      .getList("Personnel/getDriverById?id=" + personnelId)
      .pipe(take(1))
      .subscribe(
        (data: Personnel) => {
          const index = this.drivers.findIndex((x) => x.Id === data.Id);
          data.CurrentBranch = data.Branches?.find((x) => x.BranchId === this.accountService.authService.currentBranchId);
          this.drivers[index] = data;
          if (!this.currentDriverFilter) {
            this.currentDriverFilter = this.DriverFilter[0].key;
            this.DriverFilter[0].selected = true;
          }
          this.notificationList?.forEach((f) => {
            const driver = this.drivers?.find((h) => h.Id === f?.PersonnelId);
            f.PersonnelName = driver.UserDisplayName ?? driver.FirstName + " " + driver.LastName;
            f.PersonnelImage = driver.Image;
          });
          this.driverFilterByStatus(this.currentDriverFilter);
          this.getDriverCounts();
        },
        (err) => {
          this.driverFilterByStatus(this.currentDriverFilter);
          this.getDriverCounts();
        }
      );
  }

  private getDriverCounts(): void {
    this.DriverFilter[0].count = this.drivers.filter(
      (f) =>
        f.IsActive &&
        f.CurrentBranch.DriverAttendanceStatusCode === DriverAttendanceStatus.Present &&
        f.CurrentBranch.DriverStatusCode === DriverStatus.In
    ).length;
    this.DriverFilter[1].count = this.drivers.filter(
      (f) =>
        f.IsActive &&
        f.CurrentBranch.DriverAttendanceStatusCode === DriverAttendanceStatus.Present &&
        f.CurrentBranch.DriverStatusCode === DriverStatus.Out
    ).length;
    this.DriverFilter[2].count = this.drivers.filter((f) => f.IsActive).length;
    this.DriverFilter[3].count = this.drivers.length;
  }
}
